import i18n from "./../i18n/i18n";

export function localeString(obj: any, key: string): string {
  const lang = i18n.language;
  if (obj && Object.keys(obj).includes(`${key}_${lang}`)) {
    return obj[`${key}_${lang}`];
  }
  return "- | - | - | - | - | - | -";
}
